/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'becomeacustomer/become-a-customer-success-step1': {
    width: 16,
    height: 16,
    viewBox: '0 0 68.98 68.98',
    data: '<g _fill="none" _stroke="#262422" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" data-name="Group 6421" transform="translate(.4 .4)"><path pid="0" d="M35.55 41.4H4.88A4.38 4.38 0 01.5 37V4.88A4.38 4.38 0 014.88.5h52.58a4.38 4.38 0 014.38 4.38v27.75" data-name="Path 3280"/><path pid="1" d="M60.58 1.8l-29.4 23.53L1.76 1.8" data-name="Path 3281"/><circle pid="2" cx="14.38" cy="14.38" r="14.38" data-name="Ellipse 203" transform="translate(38.93 38.93)"/><path pid="3" d="M60.84 48.53l-8.12 10.84a2.1 2.1 0 01-3.17.23l-4.2-4.2" data-name="Path 3285"/></g>'
  }
})
